import type { Plan } from "../types/pricing";
export const plans: Plan[] = [
  {
    id: "premium",
    name: "Megapack Premium",
    detail: "6 tomos + 3 bonos + 2 tomos premium",
    price: "$19.999",
    compare: "$39.990",
    cta: "Sí, quiero mi Megapack Premium",
    checkoutUrl: "https://checkout.practicandsimple.shop/cart/67577135300977:1",
    popular: true,
  },
  {
    id: "base",
    name: "Megapack Base",
    detail: "6 tomos + 3 bonos",
    price: "$14.999",
    compare: "$29.990",
    cta: "Quiero mi Megapack Base",
    checkoutUrl: "https://checkout.practicandsimple.shop/cart/67577128649073:1",
    popular: false,
  },
];
